import moment from '@/moment-gp'

export default {

  create( _, data, BACKEND ) {
    return {
      title:        data.title           || "new idea",
      description:  data.description     || "",
      sortidx:      data.sortidx         || 0,
      createdAt:    moment.currentTimeServer(BACKEND),
      deleted:      false,
      design:       null,
    }
  },

  fields: {
    title: {
      db_identifier: 't',
      validate: v => v.length < 30,
      validate_bolt_type: 'String',
      required: true,
    },
    description: {
      db_identifier: 'd',
      validate: v => v.split(' ').length > 2,
      validate_bolt_type: 'String',
    },
    sortidx: {
      db_identifier: 's',
      validate_bolt_type: 'Number',
      validate: (val) => val > 0,
      required: true,
    },
    createdAt: {
      db_identifier: 'c',
      validate_bolt_type: 'InitialTimestamp',
      validate: () => true,
      required: true,
    },
    modified: {
      model_short: 'm',
      validate_bolt_type: 'CurrentTimestamp',
      validate: () => true
    },
    deleted: {
      model_short: 'd',
      validate_bolt_type: 'Boolean',
    },
    design: {
      validate_bolt_type: 'String', // ENUM
    }
  }
};
